export const CURP_SUCCESS = 'CURP_SUCCESS'
export const CURP_FAIL = 'CURP_FAIL'
export const RFC_SUCCESS = 'RFC_SUCCESS'
export const RFC_FAIL = 'RFC_FAIL'
export const INE_SUCCESS = 'INE_SUCCESS'
export const INE_FAIL = 'INE_FAIL'